/**
 * Main API module that re-exports all API functions
 * This provides a clean, centralized import point for all API functionality
 */

import { agentFunctions } from './modules/agentApi'
import { clientEntityFunctions } from './modules/clientEntityApi'
import { analyticsFunctions } from './modules/analyticsApi'
import * as chat from './modules/chatApi'
import { getChatStreamerEvent } from './modules/chatApi'
import { chatHistoryFunctions } from './modules/chatHistoryApi'
import { messageFunctions } from './modules/messageApi'
import { userFunctions } from './modules/userApi'
import { departmentFunctions } from './modules/departmentApi'
import { jobCategoryFunctions } from './modules/jobCategoryApi'
import { tagsFunctions } from './modules/tagsApi'
import { documentFunctions } from './modules/documentApi'
import { authFunctions } from './modules/authApi'
import { modelsFunctions } from './modules/modelsApi'
import { commandFunctions } from './modules/commandApi'
import { featureFunctions } from './modules/featuresApi'

interface ApiClient {
  agent: typeof agentFunctions
  clientEntity: typeof clientEntityFunctions
  analytics: typeof analyticsFunctions
  chat: typeof chat
  chatHistory: typeof chatHistoryFunctions
  user: typeof userFunctions
  message: typeof messageFunctions
  department: typeof departmentFunctions
  jobCategory: typeof jobCategoryFunctions
  tags: typeof tagsFunctions
  document: typeof documentFunctions
  auth: typeof authFunctions
  models: typeof modelsFunctions
  command: typeof commandFunctions
  features: typeof featureFunctions
  getChatStreamerEvent: typeof getChatStreamerEvent
}

export const apiClient: ApiClient = {
  agent: agentFunctions,
  clientEntity: clientEntityFunctions,
  analytics: analyticsFunctions,
  chat,
  chatHistory: chatHistoryFunctions,
  user: userFunctions,
  message: messageFunctions,
  department: departmentFunctions,
  jobCategory: jobCategoryFunctions,
  tags: tagsFunctions,
  document: documentFunctions,
  auth: authFunctions,
  models: modelsFunctions,
  command: commandFunctions,
  features: featureFunctions,
  getChatStreamerEvent,
}

// Export from apiConfig
export { backendUrl } from './apiConfig'

export { axiosClient } from './axiosClient'
